import { remittanceService } from '@services';
import { isEmpty, keyBy } from 'lodash-es';
import { customerService } from '~/src/services';

export default {
  fetchRemittanceList: async ({ commit }, params = {}) => {
    try {
      const { data, total, totalSum } = await remittanceService.list(params);

      commit('SET_REMITTANCE_LIST', data);
      commit('SET_TOTAL_REMITTANCE_LIST', { total, totalSum });
    } catch (error) {
      console.warn(error);
    }
  },

  async fetchRemittanceCustomers({ commit }, { data }) {
    try {
      if (Array.isArray(data) && data.length > 0) {
        const customerIds = [
          ...new Set(
            data.reduce((ids, item) => {
              ids.push(...item.customerId);

              return ids;
            }, []),
          ),
        ];

        await customerService
          .list({
            companyId: this._vm.$auth.user()?.selectedCompany?.id,
            search: { ids: customerIds },
          })
          .then(({ list: customers }) => commit('SET_REMITTANCE_CUSTOMERS', keyBy(customers, 'id')));
      }
    } catch ({ message }) {
      console.error(message);
    }
  },
  fetchRemittance: async ({}, params = {}) => {
    try {
      return await remittanceService.findOne(params);
    } catch (error) {
      console.warn(error);
    }
  },
  async upload(_, { files }) {
    try {
      const formData = new FormData();

      formData.append('companyId', this._vm.$auth.user()?.selectedCompany?.id);

      for (const file of files) {
        formData.append('file', file);
      }

      const response = await remittanceService.upload({ formData });

      return response;
    } catch ({ message }) {
      console.error(message);
    }
  },
  setSelected: ({ commit }, payload) => {
    commit('SET_SELECTED', payload);
  },
  updateTableOptions: ({ commit }, payload) => {
    commit('SET_TABLE_OPTIONS', payload);
  },
  resetTableOptions: ({ commit }) => {
    commit('RESET_TABLE_OPTIONS');
  },
};
